import { checkMultiContains, checkSingleMatch } from "./lib/check-match";

const initialState = {
    searchString: "",
    selected: {},
    selections: [],
    options: [],
    isFetching: false,
    activeIndex: -1,
    allowSearch: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SEARCH_STRING":
            return {
                ...state,
                searchString: action.searchString,
                allowSearch: action.allowSearch,
            };
        case "SET_SEARCH_START":
            return {
                ...state,
                isFetching: true,
                activeIndex: initialState.activeIndex,
            };
        case "SET_SEARCH_SUCCESS":
            return {
                ...state,
                isFetching: false,
                activeIndex: -1,
                options: action.options,
            };
        case "SET_ACTIVE_INDEX":
            return {
                ...state,
                activeIndex: action.activeIndex,
            };
        case "REMOVE_SELECTED_OPTION":
            return {
                ...state,
                selected: {},
                searchString: "",
            };
        case "SET_OPTIONS":
            return {
                ...state,
                options: action.options,
            };
        case "SET_DEFAULT_VALUE":
            const defaultStringValue = action.updatedValue && action.updatedValue.text ? action.updatedValue.text : "";

            return {
                ...state,
                ...(action.multiple ? { selections: action.updatedValue } : { selected: action.updatedValue, searchString: defaultStringValue }),
                ...(action.resetOptions ? { options: [] } : {}),
                allowSearch: false,
            };
        case "SET_SELECTED":
            return {
                ...state,
                ...(action.resetOptions ? { options: [] } : {}),
                searchString: action.searchString,
                selected: action.updatedValue,
                allowSearch: false,
            };
        case "SET_SELECTIONS":
            const isMatch = action.multiple ? checkMultiContains(action.updatedValue, state.selections) : checkSingleMatch(action.updatedValue, state.selected);

            if (isMatch) {
                return { ...state };
            }

            return {
                ...state,
                ...(action.resetOptions ? { options: [] } : {}),
                searchString: action.searchString || "",
                selections: [...state.selections, action.updatedValue],
            };
        case "REMOVE_SELECTION":
            const filteredWithRemoved = state.selections.filter((t) => t.value !== action.option.value);
            const selectionsWithRemoved = filteredWithRemoved.length ? filteredWithRemoved : action.dataType === "Picklist" ? "" : [];

            return {
                ...state,
                searchString: "",
                selections: selectionsWithRemoved,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
